import { Action } from '@ngrx/store';
import { Adventure } from '@polaris-customerweb/sharedcomponents.map';

export const AdventureAction = {
    setActiveAdventure: '[adventure] set active adventure',
    setAdventures: '[adventure] set adventure',
};

export class SetActiveAdventure implements Action {
    type = AdventureAction.setActiveAdventure;
    constructor(public adventure: Adventure | undefined) {}
}

export class SetAdventures implements Action {
    type = AdventureAction.setAdventures;
    constructor(public adventures: Adventure[]) {}
}
